import React from 'react';
import { R } from '@leverege/value-resolver';
import { useValueChange } from '@leverege/ui-hooks';
import { MultiSelector } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
function create(Model, options) {
  return function AliasEqualsSelector(props) {
    const {
      value
    } = props;
    const onChange = useValueChange(Model, props);
    return /*#__PURE__*/_jsx(MultiSelector, {
      eventData: "setValue1",
      onChange: onChange,
      value: value?.value1 || [],
      values: R(options)
    });
  };
}
export default {
  create
};